import { useSelector } from 'react-redux';

import { DepositRatesModel } from '../../../../interfaces/depositRates';
import { depositRatesSelector } from '../../../../store/selectors/depositRates';

export function useDepositRates(): DepositRatesModel[] {
  return useSelector(depositRatesSelector);
}
